type Modify<T, R> = Omit<T, keyof R> & R;

export type Size = {
    human_size: string;
    localized_sizes: LocalizedSizes | null;
    min_price: string;
    raw_size: string;
    retailer_size: NormalizedSize;
};

export type LocalizedSizes = {
    [tag: string]: NormalizedSize;
};

export type NormalizedSize = {
    display_size: string;
    tag: string | null;
};

export type LocalizedSize = Modify<Size, { localized_sizes: LocalizedSizes }>;

const defaultNormalizedSize = {
    display_size: "5 UK",
    tag: null,
};

export function NormalizedSizeFactory(
    partialNormalizedSize?: Partial<NormalizedSize>
): NormalizedSize {
    return { ...defaultNormalizedSize, ...partialNormalizedSize };
}

const defaultSize: Size = {
    human_size: "5 UK",
    localized_sizes: null,
    min_price: "£32.00",
    raw_size: "5",
    retailer_size: NormalizedSizeFactory(),
};

export function SizeFactory(partialSize?: Partial<Size>): Size {
    return { ...defaultSize, ...partialSize };
}
